module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_6-623c7bed8473756bbdcb9ad22e54e148.jpg";